import { render, staticRenderFns } from "./UserGlobalAlert.vue?vue&type=template&id=2c2dd12e&scoped=true&"
import script from "./UserGlobalAlert.vue?vue&type=script&lang=js&"
export * from "./UserGlobalAlert.vue?vue&type=script&lang=js&"
import style0 from "./UserGlobalAlert.vue?vue&type=style&index=0&id=2c2dd12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2dd12e",
  null
  
)

export default component.exports